;
(function ($) {
  var dataKey = 'app.dropdown';
  var Dropdown = function Dropdown(element, options) {
    this.element = element;
    this.init(options);
  };
  Dropdown.prototype = {
    attr: {
      menu: 'data-dropdown-menu',
      trigger: 'data-dropdown-toggle'
    },
    classes: {
      show: 'show'
    },
    /**
     * Initialise Dropdown
     * Listens for the user clicking on the dropdown to open or close the menu. 
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      var $dropDownMenu = this._getDropdownMenu();
      var $dropDownTrigger = this._getDropdownTrigger();
      $($dropDownTrigger).on('click', function () {
        $dropDownMenu.toggleClass(_this.classes.show);
      });
      $(window).click(function (e) {
        var $target = $(e.target);
        if (!$target.is($dropDownTrigger)) {
          if ($dropDownMenu.hasClass(_this.classes.show)) {
            $dropDownMenu.toggleClass(_this.classes.show);
          }
        }
      });
      $dropDownMenu.click(function (e) {
        e.stopPropagation();
      });
    },
    /**
     * Get Dropdown menu
     * Returns the dropdown content menu element.
     * @private
     */

    _getDropdownMenu: function _getDropdownMenu() {
      return this.element.find('[' + this.attr.menu + ']');
    },
    /**
     * Get Dropdown trigger
     * Returns the dropdown trigger element.
     * @private
     */

    _getDropdownTrigger: function _getDropdownTrigger() {
      return this.element.find('[' + this.attr.trigger + ']');
    }
  };

  /**
   * Global callback function which by default all [data-dropdown] triggers this plugin.
   * @method $.fn.app_dropdown()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_dropdown();
   */

  $.fn.app_dropdown = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Dropdown) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Dropdown(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);